<template>
  <div>
    <AutorizationMain />
  </div>
</template>

<script>
import AutorizationMain from "../components/autorization/AutorizationMain.vue";

export default {
  name: "AutorizationList",
  components: { AutorizationMain },
};
</script>
